import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import {TitleAdmin, AdminSection} from './components';
import {AboutVideo, AboutMedia, AboutMember} from './section';

const adminLnb = [
  {
    name: '비디오',
    url: "video",
    path: "/admin/about/video",
    component: AboutVideo
  },
  {
    name: '맴버',
    url: "member",
    path: "/admin/about/member",
    component: AboutMember
  },{
    name: '미디어',
    url: "media",
    path: "/admin/about/media",
    component: AboutMedia
  }
]

const AdminAbout = () => {

  return (
    <div className="AdminAbout">
      <div className="admin-header">
        <div className="con admin">
          <TitleAdmin title = "ABOUT" lnb  = {adminLnb} />
        </div>
      </div>

      <div className="admin-contents">
        <div className="con admin">
          <AdminSection>
            <Switch>
              <Redirect exact from="/admin/about" to={adminLnb[0].path} />
              {adminLnb.map(el=> {
                return <Route path={el.path} component={el.component} key = {el.name}/>
              })}
            </Switch>
          </AdminSection>

        </div>
      </div>
    </div>
  );
}

export default AdminAbout;